import { Alert, Form, Row, Col, Tooltip } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { useEffect, useState } from "react"
import { Commons, Const } from "./constants";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, SelectWithSearch, AddNewButton } from "@comps/components"
import { createSelectList } from '@comps/commonFunctions';
import CreateEncashmentType from '../policyManagement/settings/encashmentTypes/components/CreateEncashmentType';
import CreateDeductionType from '../policyManagement/settings/deductionTypes/components/CreateDeductionType';
const langKey = Const["policySlab"].lngKey
const formName = "createPolicySlab";

const fieldLabel = (field) => trans(`${langKey}.${field.langkey || field.name}`);
const deductionTypeLabel = (field) => (
  <span>
    { fieldLabel(field) } <Tooltip title="Flat deducts one fixed amount. Percentage deducts a percentage of the selected salary formula. As Per Actual increases or decreases with the deductible minutes."><InfoCircleOutlined className="da-ml-4" /></Tooltip>
  </span>
);

const CreatePolicySlab = (props) => {

  const [deductionTypes, setDeductionTypes] = useState([])
  const [encashmentTypes, setEncashmentTypes] = useState([])
  const [fromSalary, setFromSalary] = useState(false)
  const [repeatTypes,setRepeats]=useState([]);
  const [childComponent, setChildComponent] = useState(null);
  const [fallBackTypes,setFallbackTypes]=useState([]);
  const [form] = Form.useForm()
  useEffect(() => {
    getRelatedData()
    // eslint-disable-next-line
  }, []);

  const getRelatedData = () => {
    if (props.policyType === 'overtime' || props.policyType === 'cpl') {
      setEncashmentTypes(createSelectList(props.allData.encashment_types))
      //setEncashmentTypesAll(props.allData.encashment_types)
    }
    else {
      //setDeductionTypesAll(props.allData.deduction_types)
      setDeductionTypes(createSelectList(props.allData.deduction_types))
      setRepeats(createSelectList(props.allData.repeats))
    }
  }

  const onChangeDeductionType = (id) => {
    let fallbacks=[];
    if (props.policyType === 'overtime' || props.policyType === 'cpl') {
      props.allData.encashment_types.forEach(each => {
        if (each.id === id) {
          setFromSalary(each.from_salary)
        }
        if(each.from_salary){
          fallbacks.push(each)
        }
      })

    }
    else {
      props.allData.deduction_types.forEach(each => {
        if (each.id === id) {
          setFromSalary(each.from_salary)
        }
        if(each.from_salary){
          fallbacks.push(each)
        }
      })
    }

setFallbackTypes(createSelectList(fallbacks));
  }
  const onSubmit = (data) => {
    props.onCompleted(data, 'Added')
  }

  const onAddChild = (field) => {
    if (field === 'encashment_type_id') {
      setChildComponent(<CreateEncashmentType onCompleted={ (data) => onChildCreated(data, field) } />)
    }
    if (field === 'fallback_type_id' || field === 'deduction_type_id') {
      setChildComponent(<CreateDeductionType onCompleted={ (data) => onChildCreated(data, field) } />)
    }

  }
  const onChildCreated = (data, field) => {
    if (data.length) {

      if (field === 'encashment_type_id') {
        setEncashmentTypes(createSelectList(data))
      }
      if (field === 'fallback_type_id' || field === 'deduction_type_id') {
        setDeductionTypes(createSelectList(data))
      }
      form.setFieldValue(field, data[0].id)
    }
    setChildComponent(null);
  }


  const footer = [
    <SaveButton form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];
  return (

    <ModalComponent top={ 20 } width={ 1000 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      { childComponent }
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit } form={ form } scrollToFirstError>
        <Row gutter={ 30 }>
          {
            props.fields.map((field) => (
              field.type === 'text' || field.type === 'number' ?
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>

                  <Form.Item name={ field.name } rules={ rules[field.name] } label={ fieldLabel(field) }

                  >
                    <InputText type={ field.type } placeholder={ fieldLabel(field) } />
                  </Form.Item>
                </Col>
                :
                field.name === 'repeat_id' ?


                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name={ field.name } rules={ rules[field.name] } label={ fieldLabel(field) }
                    >
                      <SelectWithSearch options={ field.options } placeholder={ fieldLabel(field) } />
                    </Form.Item>
                  </Col>
                  :
                  field.name === 'deduction_type_id' ?
                    <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                      <AddNewButton text={ field.name } onClick={ () => onAddChild(field.name) } />
                      <Form.Item name={ field.name } rules={ rules[field.name] } label={ deductionTypeLabel(field) }
                      >
                        <SelectWithSearch options={ deductionTypes } onChange={ field.name === 'deduction_type_id' ? onChangeDeductionType : null } placeholder={ fieldLabel(field) } />
                      </Form.Item>
                      <Alert className="da-mb-16" type="info" showIcon message="Flat = fixed amount per applicable slab; Percentage = selected percentage of salary/balance; As Per Actual = percentage adjusted to the actual deductible minutes." />
                    </Col>
                    :
                    field.name === 'encashment_type_id' ?
                      <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                        <AddNewButton text={ field.name } onClick={ () => onAddChild(field.name) } />
                        <Form.Item name={ field.name } rules={ rules[field.name] } label={ fieldLabel(field) }
                        >
                          <SelectWithSearch options={ encashmentTypes } onChange={ field.name === 'encashment_type_id' ? onChangeDeductionType : null } placeholder={ fieldLabel(field) } />
                        </Form.Item>
                      </Col>
                      :
                      !fromSalary && field.name === 'fallback_type_id' ?
                        <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                          <AddNewButton text={ field.name } onClick={ () => onAddChild(field.name) } />
                          <Form.Item name={ field.name } rules={ rules[field.name] } label={ fieldLabel(field) }
                          >
                            <SelectWithSearch options={ fallBackTypes } placeholder={ fieldLabel(field) } />
                          </Form.Item>
                        </Col>
                        : ''

            ))
          }
        </Row>

      </Form>
    </ModalComponent>

  )
}
export default CreatePolicySlab
const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
const rules = {
  min_times: [
    { required: true, message: trans(`${langKey}.min_times`) },
  ],
  min: [
    { required: true, message: trans(`${langKey}.min`) },
  ],
  max: [
    { required: true, message: trans(`${langKey}.max`) },
  ],
  start_mins: [
    { required: true, message: trans(`${langKey}.start_mins`) },
  ],
  repeat_id: [
    { required: true, message: trans(`${langKey}.repeat_id`) },
  ],
  deduction_type_id: [
    { required: true, message: trans(`${langKey}.deduction_type_id`) },
  ],
  fallback_type_id: [
    { required: true, message: trans(`${langKey}.fallback_type_id`) },
  ],

}

//required props
//!slab.deduction_type.from_salary (fallback type)
